const currencyFormatterUSDCart = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
const getImpactConfig = () =>
  // @ts-ignore
  fetch(window.Shopify.routes.root + 'cart.js')
    .then((response) => response.json())
    .then((cartData) => {
      fetch('/apps/impact-config/api/shop-config', {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
        cache: 'no-store',
      })
        .then((response) => response.json())
        .then(function (body) {
          const isAboveMinimum = body.everyOrderMinimumSpend
            ? cartData.total_price / 100 > Number(body.everyOrderMinimumSpend)
            : true;
          const formattedMinSpend = currencyFormatterUSDCart.format(body.everyOrderMinimumSpend);
          const spendRemaining = !isAboveMinimum ? Number(body.everyOrderMinimumSpend) - cartData.total_price / 100 : 0;
          const formattedSpendRemaining = currencyFormatterUSDCart.format(spendRemaining);
          const tileTitle = isAboveMinimum
            ? `${body.everyOrderQuantity?.toString()} lbs of plastic will be collected with this order`
            : `Spend an additional ${formattedSpendRemaining} and we will collect ${body.everyOrderQuantity?.toString()} lbs of plastic waste.`;
          const tileDescription = `When your cart total reaches ${formattedMinSpend} we will fund the removal of ${body.everyOrderQuantity?.toString()} lbs of plastic waste.`;

          // @ts-ignore
          document.getElementById('cart-title').innerHTML = tileTitle;
          // @ts-ignore
          document.getElementById('ow-banner').style.display = 'flex';
          // @ts-ignore
          document.getElementById('cart-description').style.display = 'block';

          if (body.appStatus !== 'ACTIVE') {
            // @ts-ignore
            document.getElementById('ow-banner').style.display = 'none';
          }
          if (Number(body.everyOrderMinimumSpend) && !isAboveMinimum) {
            // @ts-ignore
            document.getElementById('cart-description').innerHTML = tileDescription;
          } else {
            // @ts-ignore
            document.getElementById('cart-description').style.display = 'none';
          }
        });
    });
getImpactConfig();

// Crazy but in order to track changes to the Cart we need to intercept Shopify fetch request with the following code:
// https://stackoverflow.com/questions/64236128/script-tag-xhr-event-listener-for-monitoring-cart-activities-does-not-work-anymo/64241104#64241104
(function (ns, fetch) {
  if (typeof fetch !== 'function') return;

  ns.fetch = function () {
    const response = fetch.apply(this, arguments);

    response.then((res) => {
      if (
        [
          `${window.location.origin}/cart/add`,
          `${window.location.origin}/cart/update`,
          `${window.location.origin}/cart/change`,
          `${window.location.origin}/cart/clear`,
        ].some((str) => res.url.includes(str))
      ) {
        res
          .clone()
          .json()
          .then((data) => {
            getImpactConfig();
          });
      }
    });

    return response;
  };
})(window, window.fetch);
